import {FC, useCallback} from 'react';
import {Form, Formik} from 'formik';
import {useNavigate} from 'react-router';
import {Col, Row} from "react-bootstrap";
import {FormPageFooter, FormPageHeader} from "@components/falcon/common/forms";
import {BaseInfoBlock} from "@components/consumer/goalGroups/forms";
import * as Yup from "yup";
import {toastr} from "@/utils/toastHelper";
import ConsumerRefService from "@api/consumer/consumerRefService";
import withPage from "@components/hoc/withPage";

interface AddGoalGroupFormValues {
    name: string;
    description: string;
}

const AddGoalGroupForm: FC = () => {

    const navigate = useNavigate();

    const initialValues: AddGoalGroupFormValues = {
        name: '',
        description: ''
    }

    const validationSchema = Yup.object<AddGoalGroupFormValues>({
        name: Yup.string()
            .max(256)
            .required(),
        description: Yup.string()
            .max(10000)
    });

    const onSubmit = useCallback(async (values: AddGoalGroupFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putGoalGroup({
            name: values.name,
            description: values.description
        });

        if (result.success) {
            toastr.success("Создание группы", "Группа достижений успешно создана");
            navigate(`/consumer/goals/groups/${result.data.id}/`, { replace: true });
        }
        else {
            toastr.error('Создание группы', 'Неизвестная ошибка');
        }
    }, [navigate]);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            <Form>
                <Row className="g-3">
                    <Col xs={12}>
                        <FormPageHeader title="Создание группы достижений" />
                    </Col>
                    <Col xs={12}>
                        <BaseInfoBlock />
                    </Col>
                    <Col>
                        <FormPageFooter
                            cancelUrl={'/consumer/goals/groups/'}
                        />
                    </Col>
                </Row>
            </Form>
        </Formik>
    )
}

export default withPage(AddGoalGroupForm);
